import React from 'react';
import TableCommonHook from '@op/components/TableCommonHook';
import { useVersionVideo } from '../../hooks/useVersionVideo';
import { useVideoColumn } from '@op/components/TableCommonHook/hooks/useVideoColumn';

export default function VideoTable({
  filter,
  gameInfo,
  wholeGameInfo,
}: {
  filter: any;
  gameInfo: any;
  wholeGameInfo: any;
}) {
  const { data, total, loading, sortBy, setSortBy, keys } = useVersionVideo({ filter });

  const { columns, sortColumns } = useVideoColumn({
    wholeGameInfo,
    gameInfo,
    keys: ['comment_time', ...keys],
    hasDetailPage: true,
    hasHeaderTranlsate: true,
    sorts: sortBy,
    setSorts: setSortBy,
  });

  return (
    <TableCommonHook
      recordKey={'comment_uin'}
      records={data}
      loading={loading}
      columns={columns} 
      total={total}
      bordered={false}
      sortType="local"
      hasPageable={false}
      sortInfo={[sortBy, setSortBy]}
      maxHeight={670}
      minWidth={1350}
      sortColumns={sortColumns}
    ></TableCommonHook>
  );
}
